import React from 'react';

import { TasksProvider } from './context/provider';
import { TasksFilters } from './components/filters';
import { TasksList } from './components/list';
import { TasksModal } from './components/modal';
import { TasksNewButton } from './components/new_button';
import { TasksPagination } from './components/pagination';

import type { ReactNode } from 'react';
import type { ForUser, Task as TaskType } from 'bundles/apex/tasks/types';
import type { Parent } from 'bundles/crm/types';
import type { Props as TaskProps } from './task';

import './styles.scss';

export { useTasks } from './context/tasks_context';
export type { TasksFiltersProps } from './components/filters';

// TODO: Consistent props (hide vs show) would be nice...
export interface Props {
  children: ReactNode;
  currentParent?: Parent;
  dateRangeEnabled?: boolean;
  features?: TaskProps['features'];
  forUser: ForUser;
  hideAssignees?: boolean;
  inline?: boolean;
  options?: {
    assignees?: [];
    parents?: [];
  };
  paginate?: boolean;
  paths: {
    attachments: string;
    checkForImmediateReminders: string;
    create?: string;
    formDependenciesPath: string;
  };
  showParents?: TaskProps['showParents'];
  showRouterPrompt?: boolean;
  tasks?: TaskType[];
  tbdEnabled?: boolean;
}

function Tasks({
  children,
  currentParent,
  dateRangeEnabled,
  features,
  forUser,
  hideAssignees = false,
  inline = false,
  options = {},
  paginate,
  paths,
  showParents,
  showRouterPrompt,
  tasks: tasksProp,
  tbdEnabled,
}: Props) {
  return (
    <TasksProvider
      currentParent={currentParent}
      dateRangeEnabled={dateRangeEnabled}
      features={features}
      forUser={forUser}
      hideAssignees={hideAssignees}
      inline={inline}
      options={options}
      paginate={paginate}
      paths={paths}
      showParents={showParents}
      showRouterPrompt={showRouterPrompt}
      tasks={tasksProp}
      tbdEnabled={tbdEnabled}
    >
      {children}
      <TasksModal/>
    </TasksProvider>
  );
}

Tasks.Filters = TasksFilters;
Tasks.List = TasksList;
Tasks.NewButton = TasksNewButton;
Tasks.Pagination = TasksPagination;

export default Tasks;
